/** SPA route for OAuth2 popup redirect (must match `routes.tsx`). */
export const OAUTH2_POPUP_CALLBACK_PATH = '/oauth2/popup-callback';
